import { ReactNode } from "react";
import { useViewport } from "src/contexts";
import { AutoSlidingCarousel } from "~components";
import { Css } from "~generated/css";

type LandingCtaWrapperProps = {
  title: string;
  children: ReactNode;
};

export function LandingCtaWrapper({ title, children }: LandingCtaWrapperProps) {
  const { isMobile } = useViewport();
  if (isMobile) {
    return (
      <div css={Css.df.fdc.jcc.aic.mvh100.bgWhite.mya.$}>
        <div css={Css.df.fdc.gap3.px3.jcc.aic.$}>
          <img src="/logo.svg" width="156" height="25" alt="Homebound" />
          <div css={Css.tac.gray800.fsPx(39).fw400.lh("1.26em").add("letterSpacing", "-0.04em").$}>{title}</div>
        </div>
        <div css={Css.w100.mt7.mbPx(70).$}>
          <AutoSlidingCarousel
            images={["mobile-landing-property-1.jpg", "mobile-landing-property-3.jpg", "mobile-landing-property-4.jpg"]}
          />
        </div>
        {children}
      </div>
    );
  }

  return (
    <div css={Css.df.fdc.jcc.aic.vh100.gap5.$}>
      <img src="/logo.svg" width="153" height="26" alt="Homebound" />
      <div css={Css.gray800.fsPx(48).fw400.lh("1.26em").add("letterSpacing", "-0.04em").tac.$}>{title}</div>
      <div css={Css.w100.fs0.$}>
        <AutoSlidingCarousel
          images={[
            "landing-property-1.jpg",
            "landing-property-2.jpg",
            "landing-property-3.jpg",
            "landing-property-4.jpg",
          ]}
          isDesktop
        />
      </div>
      {children}
    </div>
  );
}
